import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createNewBooking,
  getBookingHistoryDetail,
  getYachtAction,
} from "../../../../redux/booking/BookingSlice";
import BoatHelm from "../../../../Asset/icon/boat_helm.svg";
import { Form, FormGroup, FormControl, Button } from "react-bootstrap";
import { Snackbar, Alert } from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DatePicker, ConfigProvider } from "antd";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import "dayjs/locale/th";
import { useNavigate } from "react-router-dom";

import { getYachtInfoSellingPriceRatePlanListDetail } from "../../../../redux/YachtInfoSellingPriceRatePlanList/YachtInfoSellingPriceRatePlanListSlice";
import { getYachtInfoAmenitiesDetail } from "../../../../redux/YachtInfoAmenities/YachtInfoAmenitiesSlice";
import { getYachtInfoWaterToyDetail } from "../../../../redux/YachtInfoWaterToy/YachtInfoWaterToySlice";
import { getYachtInfoGalleryDetail } from "../../../../redux/yachtInfoGallery/YachtInfoGallerySlice";
import { getYachtInfoDestinationPackageDetail } from "../../../../redux/yachtInfoDestinationPackage/YachtInfoDestinationPackageSlice";
import { getYachtDetail } from "../../../../redux/yacht/YachtSlice";
import {
  getMarinaDetail,
  getDestinationDetail,
  getProvinceDetail,
} from "../../../../redux/centerData/CenterDataSlice";
import {
  getUserDetail,
  sendEmailBookingAction,
} from "../../../../redux/Auth/AuthSlice";
import LoginModal from "../../../user/login";
import thTH from "antd/locale/th_TH";

const BookingForm = ({
  bookingYacht,
  price,
  originalPrice,
  discountType,
  discountValue,
  promotionCode,
}) => {
  const { t } = useTranslation();
  const { slug } = useParams();
  const todos = useSelector((state) => state);
  const dispatch = useDispatch();
  const isAuth = useSelector((state) => state.AuthSlice.isAuthenticated);
  const token = useSelector((state) => state.AuthSlice.token);
  const userDetails = useSelector((state) => state.AuthSlice.user);
  const getToken = useSelector((state) => state.AuthSlice.token);
  const { RangePicker } = DatePicker;
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [selectedDates, setSelectedDates] = useState("");

  // const [showBookedAlert, setShowBookedAlert] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (isAuth && token) {
        await dispatch(getUserDetail({ token }));
      }

      Promise.all([
        dispatch(getDestinationDetail({})),
        dispatch(getYachtInfoSellingPriceRatePlanListDetail({})),
        dispatch(getMarinaDetail({})),
        dispatch(getProvinceDetail({})),
        dispatch(getYachtAction({})),
        dispatch(getYachtDetail({})),
        dispatch(getYachtInfoAmenitiesDetail({})),
        dispatch(getYachtInfoWaterToyDetail({})),
        dispatch(getYachtInfoGalleryDetail({})),
        dispatch(getYachtInfoDestinationPackageDetail({})),
        dispatch(getBookingHistoryDetail({ token: getToken })),
      ])
        .then(() => {
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    };

    fetchData();
  }, [dispatch, isAuth, token]);

  const selectedYacht = loading
    ? null
    : todos.YachtInfoSellingPriceRatePlanListSlice.YachtInfoSellingPriceRatePlanList.results.find(
      (YachtInfoSellingPriceRatePlanList) =>
        YachtInfoSellingPriceRatePlanList.id_sellingPrice === slug
    );

  const selectedYachtWithMarinaAndProvince = loading
    ? null
    : (() => {
      const marina = todos.CenterDataSlice.Marina.results.find(
        (marina) => marina.id_marina === selectedYacht.id_marina
      );

      const province = todos.CenterDataSlice.Province.results.find(
        (province) => province.ProvinceID === marina?.id_province
      );

      const travelAgent =
        selectedYacht.id_yacht &&
        todos.YachtSlice.Yacht.results.find(
          (yacht) => yacht.id_yacht === selectedYacht.id_yacht
        );

      const YachtInfoAmenities =
        todos.YachtInfoAmenitiesSlice.YachtInfoAmenities.results.filter(
          (yachtInfoAmenities) =>
            yachtInfoAmenities.id_yachtInfo === selectedYacht.id_yachtInfo
        );
      const YachtInfoWaterToy =
        todos.YachtInfoWaterToySlice.YachtInfoWaterToy.results.filter(
          (yachtInfoWaterToy) =>
            yachtInfoWaterToy.id_yachtInfo === selectedYacht.id_yachtInfo
        );
      const YachtInfoGallery =
        todos.YachtInfoGallerySlice.YachtInfoGallery.results.filter(
          (yachtInfoGallery) =>
            yachtInfoGallery.id_yachtInfo === selectedYacht.id_yachtInfo
        );
      const YachtInfoDestinationPackage =
        todos.YachtInfoDestinationPackageSlice.YachtInfoDestinationPackage.results.find(
          (yachtInfoDestinationPackage) =>
            yachtInfoDestinationPackage.id_destination_package ===
            selectedYacht.id_destination_package
        );

      const destinationIds =
        todos.YachtInfoDestinationPackageSlice.YachtInfoDestinationPackage.results.find(
          (desID) =>
            desID.id_destination_package ===
            selectedYacht.id_destination_package
        )?.destination_included;

      const destinationIdsArray = destinationIds
        ? destinationIds.split(",")
        : [];
      const DestinationEng = destinationIdsArray
        .map((destinationId) => {
          const destination = todos.CenterDataSlice.Destination.results.find(
            (destination) => destination.id_destination === destinationId
          );
          return destination ? destination.name_destination_en : null;
        })
        .join(",");

      const DestinationThai = destinationIdsArray
        .map((destinationId) => {
          const destination = todos.CenterDataSlice.Destination.results.find(
            (destination) => destination.id_destination === destinationId
          );
          return destination ? destination.name_destination_th : null;
        })
        .join(",");

      return {
        ...selectedYacht,
        name_marina_en: marina ? marina.name_marina_en : null,
        name_marina_th: marina ? marina.name_marina_th : null,
        ProvinceEng: province ? province.ProvinceEng : null,
        ProvinceThai: province ? province.ProvinceThai : null,
        ProvinceID: province ? province.ProvinceID : null,
        travelAgent: travelAgent ? travelAgent.name_yacht : null,
        YachtInfoAmenities: YachtInfoAmenities,
        YachtInfoWaterToy: YachtInfoWaterToy,
        YachtInfoGallery: YachtInfoGallery,
        YachtInfoDestinationPackage: YachtInfoDestinationPackage,
        destinationIds: destinationIds,
        DestinationEng: DestinationEng,
        DestinationThai: DestinationThai,
      };
    })();

  const [tel, setTel] = useState(userDetails?.mobile_no || "");
  const [firstName, setFirstName] = useState(userDetails?.firstname || "");
  const [lastName, setLastName] = useState(userDetails?.lastname || "");
  const [email, setEmail] = useState(userDetails?.email || "");
  const [comment, setComment] = useState("");
  const [selectedDate, setSelectedDate] = useState(
    localStorage.getItem("selectedDate")
  );

  const [tripType, setTripType] = useState(
    selectedYachtWithMarinaAndProvince?.rate_type || ""
  );
  const [counters, setCounters] = useState(
    JSON.parse(localStorage.getItem("Passenger")) || {
      adults: 0,
      children: 0,
      infants: 0,
    }
  );
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}/${month}/${day}`;
  };

  const calcOvernightStay = (dateRange) => {
    if (!dateRange) return 0;

    // หา substring ที่เป็นรูปแบบวันที่ (yyyy-mm-dd หรือ yyyy/mm/dd)
    const matches = String(dateRange).match(/(\d{4}[\/-]\d{1,2}[\/-]\d{1,2})/g);
    if (!matches || matches.length < 2) {
      // ถ้ามีรูปแบบเป็น "2025/11/24,2025/11/26" หรือแยกด้วย comma
      const alt = String(dateRange)
        .split(/[,|;]/)
        .map((s) => s.trim())
        .filter(Boolean);
      if (alt.length >= 2) {
        const startAlt = dayjs(alt[0].replace(/-/g, "/").trim());
        const endAlt = dayjs(alt[1].replace(/-/g, "/").trim());
        if (startAlt.isValid() && endAlt.isValid()) {
          const nightsAlt = endAlt.diff(startAlt, "day");
          return nightsAlt > 0 ? nightsAlt : 0;
        }
      }
      return 0;
    }

    const start = dayjs(matches[0].replace(/-/g, "/").trim());
    const end = dayjs(matches[1].replace(/-/g, "/").trim());
    if (!start.isValid() || !end.isValid()) return 0;

    const nights = end.diff(start, "day");
    return nights > 0 ? nights : 0;
  };

  useEffect(() => {
    if (!bookingYacht) return;

    if (bookingYacht.rate_type === "Overnight") {
      const dateToCalc = selectedDates || selectedDate;

      const nights = calcOvernightStay(dateToCalc);

      setBookingData((prevState) => ({
        ...prevState,
        overnight_stay: nights,
      }));
    } else {
      // ถ้าไม่ใช่ Overnight ให้เป็น 0
      setBookingData((prevState) => ({
        ...prevState,
        overnight_stay: 0,
      }));
    }
  }, [selectedDate, selectedDates, bookingYacht]);

  const [bookingData, setBookingData] = useState({
    activity_date: dayjs(selectedDate || selectedDates).format("YYYY/MM/DD"),
    adult: counters.adults,
    child: counters.children,
    infant: counters.infants,
    // sum_all_price: bookingYacht.value_sellingPrice,
    sum_all_price:
      price !== originalPrice ? price : bookingYacht.value_sellingPrice,
    status: "INQUIRY",
    id_customer_type: "0000000001",
    activity_type: bookingYacht.rate_type,
    overnight_stay:
      bookingYacht?.rate_type === "Overnight"
        ? calcOvernightStay(selectedDates || selectedDate)
        : 0,
    issued_date: formatDate(new Date()),
    guest_name: `${firstName} ${lastName}`,
    id_yachtInfo: bookingYacht.id_yachtInfo,
    yacht_name: bookingYacht.name_yacht_yachtInfo,
    comment: comment,
    id_yacht: bookingYacht.id_yacht,
    email: userDetails?.email,
    firstName: userDetails?.firstname,
    lastName: userDetails?.lastname,
    tel: userDetails?.mobile_no,
    idPassport: userDetails?.id_passport,
    birthDate: userDetails?.date_of_birth,
    id_country: userDetails?.country_value,
    id_nationality: userDetails?.idNationality,
    gender: userDetails?.gender,
    // sum_price: bookingYacht.value_sellingPrice,
    sum_price:
      price !== originalPrice ? price : bookingYacht.value_sellingPrice,
    sum_surcharge: 0,
    id_destination_package: bookingYacht.id_destination_package,
    id_ratePlanList: bookingYacht.id_ratePlanList,
    id_sellingPrice: bookingYacht.id_sellingPrice,
    type_sellingPrice: bookingYacht.type_sellingPrice,
    // value_sellingPrice: bookingYacht.value_sellingPrice,
    value_sellingPrice:
      price !== originalPrice ? price : bookingYacht.value_sellingPrice,
    name_ratePlan: bookingYacht.name_ratePlan,
    id_ratePlan: bookingYacht.id_ratePlan,
  });

  useEffect(() => {
    if (userDetails && bookingYacht) {
      setBookingData((prevState) => ({
        ...prevState,
        tel: userDetails?.mobile_no,
        email: userDetails?.email,
        firstName: userDetails?.firstname,
        lastName: userDetails?.lastname,
        mobileNo: userDetails?.mobile_no,
        idPassport: userDetails?.id_passport,
        birthDate: userDetails?.date_of_birth,
        id_country: userDetails?.country_value,
        id_nationality: userDetails?.idNationality,
        gender: userDetails?.gender,
        activity_date: (() => {
          const formatDate = (dateStr) =>
            dayjs(dateStr.replace(/-/g, "/")).format("YYYY/MM/DD");

          if (selectedDate) {
            if (selectedDate.includes(",")) {
              return selectedDate
                .split(",")
                .map((d) => formatDate(d.trim()))
                .join(",");
            }
            return formatDate(selectedDate.trim());
          }

          if (selectedDates) {
            return selectedDates
              .split(",")
              .map((d) => formatDate(d.trim()))
              .join(",");
          }

          return "";
        })(),

        // sum_all_price: bookingYacht?.value_sellingPrice || 0,
        sum_all_price:
          price !== originalPrice ? price : bookingYacht.value_sellingPrice,
        activity_type: bookingYacht?.rate_type || "",
        overnight_stay:
          bookingYacht?.rate_type === "Overnight"
            ? calcOvernightStay(selectedDates || selectedDate)
            : 0,
        guest_name: `${userDetails?.firstname || ""} ${userDetails?.lastname || ""
          }`,
        id_yachtInfo: bookingYacht?.id_yachtInfo || "",
        yacht_name: bookingYacht?.name_yacht_yachtInfo || "",
        id_yacht: bookingYacht?.id_yacht || "",
        comment: comment || "",
        // sum_price: bookingYacht.value_sellingPrice,
        sum_price:
          price !== originalPrice ? price : bookingYacht.value_sellingPrice,
        sum_surcharge: 0,
        id_destination_package: bookingYacht.id_destination_package,
        id_ratePlanList: bookingYacht.id_ratePlanList,
        id_sellingPrice: bookingYacht.id_sellingPrice,
        type_sellingPrice: bookingYacht.type_sellingPrice,
        // value_sellingPrice: bookingYacht.value_sellingPrice,
        value_sellingPrice:
          price !== originalPrice ? price : bookingYacht.value_sellingPrice,
      }));
    }
  }, [userDetails, bookingYacht, selectedDate, selectedDates, comment]);

  useEffect(() => {
    if (userDetails) {
      setFirstName(userDetails.firstname || "");
      setLastName(userDetails.lastname || "");
      setTel(userDetails.mobile_no || "");
      setEmail(userDetails.email || "");
    }
  }, [userDetails]);

  useEffect(() => {
    const storedDate = localStorage.getItem("selectedDate");
    if (storedDate) {
      setSelectedDate(storedDate);
    }

    if (!loading && selectedYachtWithMarinaAndProvince) {
      const storedTripType = selectedYachtWithMarinaAndProvince.rate_type;
      if (storedTripType && tripType !== storedTripType) {
        setTripType(storedTripType);
      }
    }

    const storedPassenger = JSON.parse(localStorage.getItem("Passenger"));
    if (
      storedPassenger &&
      JSON.stringify(counters) !== JSON.stringify(storedPassenger)
    ) {
      setCounters(storedPassenger);
    }
  }, [loading, selectedYachtWithMarinaAndProvince]);

  const handleTelChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setTel(value);
  };

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const showSnackbar = (message, severity = "info") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!isAuth) {
      setShowLoginPrompt(true);
      return;
    }

    if (!(selectedDate?.trim() || selectedDates?.trim())) {
      showSnackbar(
        t("Please select an activity date before making a booking."),
        "warning"
      );
      return;
    }

    const selected = selectedDate?.trim() || selectedDates?.trim();
    const selectedDay = dayjs(selected, "YYYY/MM/DD");
    const history = todos?.Booking?.BookingHistroy?.results || [];

    const isDateAlreadyBooked = history.some((item) => {
      const isSameYacht = item.id_yachtInfo === bookingYacht.id_yachtInfo;
      // const isSameActivityType =
      //   item.activity_type === bookingYacht.rate_type;
      const isNotCancelled = item.status !== "CANCELLED";

      if (!isSameYacht || !isNotCancelled) return false;

      const dates = item.activity_date
        ?.split(",")
        .map((d) => dayjs(d.trim(), "YYYY/MM/DD"));

      if (dates.length === 1) {
        return selectedDay.isSame(dates[0], "day");
      } else if (dates.length === 2) {
        const [startDate, endDate] = dates;
        return selectedDay.isBetween(startDate, endDate, "day", "[]");
      }

      return false;
    });

    if (isDateAlreadyBooked) {
      showSnackbar(
        t(
          "This activity date has already been booked. Please select another date."
        ),
        "warning"
      );
      return;
    }

    const ratePlanList =
      todos?.YachtInfoSellingPriceRatePlanListSlice
        ?.YachtInfoSellingPriceRatePlanList?.results || [];

    // หาเรทแพลนของเรือลำนี้
    const matchedRatePlan = ratePlanList.find(
      (plan) =>
        Number(plan.id_sellingPrice) === Number(bookingYacht.id_sellingPrice)
    );

    if (matchedRatePlan) {
      const startDate = dayjs(
        matchedRatePlan.start_rate_plan_date,
        "YYYY/MM/DD"
      );
      const endDate = dayjs(matchedRatePlan.end_rate_plan_date, "YYYY/MM/DD");

      const isWithinRatePlan = selectedDay.isBetween(
        startDate,
        endDate,
        "day",
        "[]"
      );

      if (!isWithinRatePlan) {
        showSnackbar(
          t(
            "The selected date is not available for this rate plan. Please choose another date."
          ),
          "warning"
        );
        return;
      }
    }

    if (
      bookingData.activity_type?.toLowerCase() === "overnight" &&
      matchedRatePlan?.minimum_stay
    ) {
      const dateParts = selected.split(",").map((d) => d.trim());

      if (dateParts.length === 2) {
        const [startStr, endStr] = dateParts;
        const startDate = dayjs(startStr, "YYYY/MM/DD");
        const endDate = dayjs(endStr, "YYYY/MM/DD");

        const nights = endDate.diff(startDate, "day");

        if (nights < matchedRatePlan.minimum_stay) {
          showSnackbar(
            t(
              `Minimum stay for this yacht is ${matchedRatePlan.minimum_stay} nights. Please extend your booking dates.`
            ),
            "warning"
          );
          return;
        }
      } else {
        showSnackbar(
          t(
            "Please select both check-in and check-out dates for overnight booking."
          ),
          "warning"
        );
        return;
      }
    }

    setIsSubmitting(true);

    try {
      // 👉 หาเจ้าของเรือจาก yachtResult
      const yachtOwnerData = todos?.Booking?.yachtResult?.data?.find(
        (y) => Number(y.id_yacht) === Number(bookingYacht.id_yacht)
      );

      const vat = yachtOwnerData?.vat; // ค่า vat (0 หรือ 1)

      const discountprice = price; // ราคาปัจจุบัน (อาจมีส่วนลด)
      const originalPrice = bookingData.value_sellingPrice; // ราคาปกติ
      let totalPrice =
        discountprice !== originalPrice ? discountprice : originalPrice;
      // let totalPrice = bookingData.sum_all_price;

      // 👉 ถ้า vat = 1 ให้บวก VAT 7%
      if (vat === 1) {
        const vatRate = 0.07;
        totalPrice = Math.round(totalPrice * (1 + vatRate));
      }

      // 👉 อัปเดตราคาก่อนส่ง booking
      const updatedBookingData = {
        ...bookingData,
        sum_all_price: totalPrice,
        use_promo: promotionCode?.trim() || null,
      };

      // 👉 สร้าง booking
      const response = await dispatch(createNewBooking(updatedBookingData));

      setShowSuccess(true);
      setIsSubmitting(false);

      const idBooking = response.bookingId;
      const BookingNo = response.bookingNo;

      const yachtOwnerEmail = yachtOwnerData?.email;
      if (!yachtOwnerEmail) {
        console.warn("Yacht owner's email not found.");
        return;
      }

      const emailData = {
        recipient: yachtOwnerEmail,
        subject: `New Booking No. [#${BookingNo}] | TakeMyYacht.com`,
        dear: yachtOwnerData?.name_yacht,
        firstName: updatedBookingData.firstName,
        lastName: updatedBookingData.lastName,
        email: updatedBookingData.email,
        tel: updatedBookingData.tel,
        message: `
<table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
  <tr>
    <td align="center">
      <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="700" style="font-family: Arial, sans-serif; color: #333; text-align: left; background-color: #ffffff;">
        <tr>
          <td style="padding: 30px;">

            <h2 style="color: #004080; margin-bottom: 10px;">📌 New Yacht Booking Inquiry Received</h2>

            <p style="font-size: 15px; color: #555;">Dear ${yachtOwnerData?.name_yacht},</p>
            <p style="font-size: 15px; color: #555;">A new yacht booking has been made. Please review the details below:</p>

            <div style="background-color: #f0f6ff; border-left: 5px solid #004080; padding: 20px; margin: 20px 0; border-radius: 8px;">
              <p style="margin: 5px 0;"><strong>Booking ID:</strong> ${idBooking}</p>
              <p style="margin: 5px 0;"><strong>Booking NO:</strong> ${BookingNo}</p>
              <p style="margin: 5px 0;"><strong>Guest Name:</strong> ${updatedBookingData.guest_name}</p>
              <p style="margin: 5px 0;"><strong>Email:</strong> ${updatedBookingData.email}</p>
              <p style="margin: 5px 0;"><strong>Phone:</strong> ${updatedBookingData.tel}</p>
              <p style="margin: 5px 0;"><strong>Yacht Name:</strong> ${updatedBookingData.yacht_name}</p>
              <p style="margin: 5px 0;"><strong>Activity Type:</strong> ${updatedBookingData.activity_type}</p>
              <p style="margin: 5px 0;"><strong>Booking Date:</strong> ${updatedBookingData.activity_date}</p>
              <p style="margin: 5px 0;"><strong>Number of Passengers:</strong> Adults ${updatedBookingData.adult}, Children ${updatedBookingData.child}, Infants ${updatedBookingData.infant}</p>
              <p style="margin: 5px 0;"><strong>Total Price:</strong> ${updatedBookingData.sum_all_price} THB</p>
              <p style="margin: 5px 0;"><strong>Booking Status:</strong> <span style="color:#e67e22; font-weight:bold;">${updatedBookingData.status}</span></p>
            </div>

            <p style="font-size: 15px; color: #555;">Please confirm your availability using the options below:</p>

            <div style="margin-top: 20px; text-align: center;">
              <a href="https://takemyyacht.com/email-action?recipient=${yachtOwnerEmail}&email=${updatedBookingData.email}&firstName=${updatedBookingData.firstName}&lastName=${updatedBookingData.lastName}&id_booking=${idBooking}&status=UNAVAILABLE&booking_no=${BookingNo}"
                 style="display: inline-block; background-color: #ffffff; color: #d32f2f; border: 2px solid #d32f2f; padding: 12px 24px; border-radius: 6px; font-weight: bold; text-decoration: none; margin-right: 10px;">
                  Occupied
              </a>

              <a href="https://takemyyacht.com/email-action?recipient=${yachtOwnerEmail}&email=${updatedBookingData.email}&firstName=${updatedBookingData.firstName}&lastName=${updatedBookingData.lastName}&id_booking=${idBooking}&status=PENDING&booking_no=${BookingNo}"
                 style="display: inline-block; background-color: #004080; color: white; border: 2px solid #004080; padding: 12px 24px; border-radius: 6px; font-weight: bold; text-decoration: none;">
                  Vacant
              </a>
            </div>

            <p style="margin-top: 40px; font-size: 14px; color: #555;">Best regards,<br/>TakeMyYacht Team</p>

          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
`,
      };

      // 👉 ส่งอีเมลหาเจ้าของเรือ
      await dispatch(sendEmailBookingAction(emailData));
    } catch (error) {
      console.error("Error during booking or email:", error);
      setIsSubmitting(false);
    }
  };

  const handleClose = () => setShowSuccess(false);

  // Login modal
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const handleOpenLoginModal = () => setLoginModalOpen(true);
  const handleCloseLoginModal = () => setLoginModalOpen(false);

  // Register modal
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);
  const handleOpenRegister = () => setIsRegisterOpen(true);
  const handleCloseRegister = () => setIsRegisterOpen(false);

  const switchToSignUp = () => setIsRegisterOpen(true);

  //handle login booking
  const handleCloseLogin = () => {
    setShowLoginPrompt(false);
    setLoginModalOpen(true);
  };

  return (
    <div className="relative">
      <div className="mb-4">
        <img
          className="BoatHelm-1"
          draggable={false}
          src={BoatHelm}
          alt="BoatHelm"
        />
        <h2>{t("Booking Inquiry")}</h2>
      </div>
      <Form
        className="row justify-content-center col-sm-6 col-md-12 mx-auto "
        onSubmit={handleSubmit}
      >
        <FormGroup className="col-12 col-xs-12 col-md-6 mb-2">
          <Form.Label className="d-flex align-items-start m-0">
            {t("First Name")} *
          </Form.Label>
          <FormControl
            type="text"
            placeholder={t("First Name")}
            value={firstName}
            onChange={handleFirstNameChange}
            required
            disabled={isAuth}
          />
        </FormGroup>
        <FormGroup className="col-12 col-xs-12 col-md-6 mb-2">
          <Form.Label className="d-flex align-items-start m-0">
            {t("Last Name")} *
          </Form.Label>
          <FormControl
            type="text"
            placeholder={t("Last Name")}
            value={lastName}
            onChange={handleLastNameChange}
            required
            disabled={isAuth}
          />
        </FormGroup>
        <FormGroup className="col-12 col-xs-12 col-md-6 mb-2">
          <Form.Label className="d-flex align-items-start m-0">
            {t("Tel.")} *
          </Form.Label>
          <FormControl
            type="tel"
            placeholder={t("Tel.")}
            value={tel}
            onChange={handleTelChange}
            required
            disabled={isAuth && tel}
          />
        </FormGroup>
        <FormGroup className="col-12 col-xs-12 col-md-6 mb-2">
          <Form.Label className="d-flex align-items-start m-0">
            {t("Email")} *
          </Form.Label>
          <FormControl
            type="email"
            placeholder={t("Email")}
            value={email}
            onChange={handleEmailChange}
            required
            disabled={isAuth}
          />
        </FormGroup>
        <FormGroup className="col-12 col-md-6 mb-2">
          <Form.Label className="d-flex align-items-start m-0">
            {t("Activity Type")}
          </Form.Label>
          <div className="d-flex flex-wrap ms-2 gap-3 mt-2">
            {["HalfDay", "DayTrip", "Overnight"].map((type) => (
              <Form.Check
                key={type}
                type="radio"
                label={type}
                name="tripType"
                value={type}
                checked={tripType === type}
                onChange={(e) => setTripType(e.target.value)}
                required
              />
            ))}
          </div>
        </FormGroup>

        <FormGroup className="col-12 col-md-6 mb-2">
          <Form.Label className="d-flex align-items-start m-0">
            {t("Activity Date")}
          </Form.Label>

          {tripType === "Overnight" ? (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <ConfigProvider
                locale={currentLanguage === "th" ? thTH : undefined}
              >
                <div className="custom-range-picker-wrapper">
                  <RangePicker
                    onChange={(dates) => {
                      if (dates) {
                        const formatted = dates.map((d) =>
                          dayjs(d).format("YYYY/MM/DD")
                        );
                        setSelectedDates(formatted.join(",")); // เก็บไว้ใช้กรณี fallback
                      } else {
                        setSelectedDates("");
                      }
                    }}
                    value={(() => {
                      const dateStr = selectedDate?.includes(",")
                        ? selectedDate
                        : selectedDates;
                      if (dateStr && dateStr.includes(",")) {
                        const [start, end] = dateStr.split(",");
                        return [dayjs(start), dayjs(end)];
                      }
                      return null;
                    })()}
                    format="YYYY/MM/DD"
                    disabledDate={(current) =>
                      current && current < dayjs().startOf("day")
                    }
                    disabled={!!selectedDate}
                    allowClear
                    className="w-full"
                  />
                </div>
              </ConfigProvider>
            </LocalizationProvider>
          ) : (
            <FormControl
              type="date"
              value={
                selectedDate
                  ? dayjs(selectedDate).format("YYYY-MM-DD")
                  : selectedDates
              }
              onChange={(e) => setSelectedDates(e.target.value)}
              required
              disabled={!!selectedDate}
              min={dayjs().format("YYYY-MM-DD")}
            />
          )}
        </FormGroup>

        <FormGroup className="col-12 mb-2">
          <Form.Label className="d-flex align-items-start m-0">
            {t("Destination Package")}
          </Form.Label>
          <FormControl
            type="text"
            value={`${bookingYacht.YachtInfoDestinationPackage.name_destination_package} (${slug})`}
            required
            disabled
          />
        </FormGroup>
        <FormGroup className="col-12 mb-2">
          <Form.Label className="d-flex align-items-start m-0">
            {t("Message")}
          </Form.Label>
          <FormControl
            as="textarea"
            rows={3}
            placeholder={t("Message")}
            value={comment}
            onChange={handleCommentChange}
          />
        </FormGroup>
        <div className="col-12 col-xs-12 col-md-12 mb-2 mx-auto d-flex justify-content-center">
          {isSubmitting ? (
            <CircularProgress />
          ) : (
            <Button
              className="w-100 w-sm-50 w-md-25"
              type="submit"
              id="province-dropdown"
            >
              {t("Submit")}
            </Button>
          )}
        </div>
      </Form>

      {showSuccess && (
        <div
          className="overlay-dark"
          onClick={handleClose}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="mx-auto modal-box" // Centering the modal horizontally
          style={{borderRadius: "16px", border: "none"}}
          >
            <div className="modal-header-custom">
              <h4 className="text-left mb-0">{t("Booking Inquiry")}</h4>

              <button
                onClick={handleClose}
                className="btn-close-icon2"
              >
                &times;
              </button>
            </div>

            <hr
              className="divider-line"
            />
            <p>
              {t(
                "Thank you for inquiry."
              )}
            </p>
             <p>
              {t(
                "Your inquiry has been sent to the agent successfully."
              )}
            </p>
            <p>{t("We will get back to you as soon as possible.")}</p>
            <Button
              id="province-dropdown"
              variant="primary"
              onClick={() => {
                handleClose();
                navigate("/userinformation");
              }}
            >
              {t("Done")}
            </Button>
          </div>
        </div>
      )}

      <LoginModal
        open={isLoginModalOpen}
        onClose={handleCloseLoginModal}
        onSignUp={switchToSignUp}
      />

      {showLoginPrompt && (
        <div
          className="overlay-dark"
        >
          <div
            className="mx-auto modal-box2"
          >
            <h2>{t("Please Log In")}</h2>
            <p>{t("You need to log in to complete the booking.")}</p>
            <Button onClick={handleCloseLogin}>{t("OK")}</Button>
          </div>
        </div>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          width: "auto",
        }}
      >
        <Alert
          sx={{
            borderRadius: 8,
          }}
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default BookingForm;
